import React from 'react';

export default function FilterChipGroup({
  title,
  items,
  selectedId,
  onSelect,
}) {
  return (
    <div className="cs-chip-group">
      <div className="cs-chip-group__header">
        <h6 className="text-success mb-0">{title}</h6>
      </div>
      <div className="cs-chip-scroll custom-scrollbar">
        {items.length > 0 ? (
          items.map((id) => (
            <button
              key={id}
              type="button"
              className={`btn cs-chip ${selectedId === id ? 'cs-chip--active' : ''}`}
              onClick={() => onSelect(id)}
            >
              {id}
            </button>
          ))
        ) : (
          <div className="text-center py-3">No matching records found</div>
        )}
      </div>
    </div>
  );
}
